import { render, staticRenderFns } from "./TwProcessGroupListItemSimple.vue?vue&type=template&id=0857c395&"
import script from "./TwProcessGroupListItemSimple.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListItemSimple.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListItemSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports